module.exports = __webpack_public_path__ + "img/测评1.822e21f2.png";